import { Component } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';


@Component({
  selector: "app-dashboard",
  templateUrl: "unauthorized.component.html",
  providers: []
})
export class UnauthorizedComponent {
    constructor(
        public authService: AuthService){
        
    }

    public login() {
        this.authService.login();
    }
 }